module.exports = __webpack_public_path__ + "img/carrusel_1.b4734684.png";